export default "__VITE_ASSET__10b67e2b__"